module.exports = __webpack_public_path__ + "img/fi-rr-stopwatch.e541df1a.svg";